import { render } from "./lrbTable.vue?vue&type=template&id=3401ce8c&scoped=true"
import script from "./lrbTable.vue?vue&type=script&lang=js"
export * from "./lrbTable.vue?vue&type=script&lang=js"

import "./lrbTable.vue?vue&type=style&index=0&id=3401ce8c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3401ce8c"]])

export default __exports__